import axios from "axios";
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
//全局添加拦截器的作用是可以在每个api前面加上headers的token验证
axios.interceptors.request.use(config => {
    // 判断token是否存在和是否需要token验证的路由
    if (sessionStorage.getItem('token')) {
        config.headers.Authorization = sessionStorage.getItem('token');
    }
    return config;
})
export default axios